<template>
    <div class="row mx-auto">
        <div class="col-md-10 col-12 mx-auto">
            <h1>{{ $gettext('Standard Responses') }}</h1>

            <div id="table-wrapper">
                <data-table
                    :columns="columns"
                    :per-page="['10', '25', '50', '100']"
                    :url="url"
                    :filters="filters"
                    ref="responsesTable"
                >
                    <div slot="filters" slot-scope="{ tableData, perPage }">
                        <div class="row mb-2">
                            <div class="col-md-4">
                                <select class="form-control w-auto me-md-2 me-0 form-input-height" v-model="filters.length">
                                    <option :key="page" v-for="page in perPage">{{ page }}</option>
                                </select>
                            </div>
                            <div class="col-md-8 d-flex flex-column flex-md-row justify-content-end">
                                <input name="search" id="search" :placeholder="$gettext('Search responses...')"
                                       class="form-control w-auto form-input-height" v-model="filters.search">
                            </div>
                        </div>
                    </div>
                    <tbody slot="body" slot-scope="{ data }">
                    <tr
                        :key="item.id"
                        v-for="item in data"
                    >
                        <td :key="column.name" v-for="column in columns"
                            @click="column.name !=='Edit' ? showRowNumber(item.id, item.type) : ''">
                            <data-table-cell
                                :value="item"
                                :name="column.name"
                                :meta="column.meta"
                                :comp="column.component"
                                :classes="column.classes"
                            >
                            </data-table-cell>
                        </td>
                    </tr>
                    </tbody>
                </data-table>
            </div>

            <modal
                :modaltitle="$gettext('Delete Response')"
                :modaltext="$gettext('Do you want to delete this response?')"
                :buttontext="$gettext('Delete')"
            ></modal>
        </div>
    </div>
</template>

<script>
import ActionTableButtons from "./ActionTableButtons.vue";
import { DataTable } from "laravel-vue-datatable";

export default {
    name: "standard-responses-table",

    props: ["base_url"],

    components: {
        ActionTableButtons,
        DataTable,
    },

    data() {
        return {
            url: "",
            showActionButtons: false,
            filters_url: {},
            rowId: "",
            selectOptions: [],
            council: {},
            filters: {
                length: 10,
                search: '',
            },
            columns: [
                {
                    label: "Id",
                    name: "id",
                    orderable: true,
                },
                {
                    label: this.$gettext("Title"),
                    name: "title",
                    orderable: true,
                },
                {
                    label: this.$gettext("Text"),
                    name: "text_cut",
                    columnName: "text",
                    orderable: true,
                },
                {
                    label: this.$gettext("Council"),
                    name: "council.name",
                    columnName: "council.name",
                    orderable: true,
                },
                {
                    label: this.$gettext("Active"),
                    name: "active_formatted",
                    columnName: "is_active",
                    orderable: true,
                },
                {
                    label: this.$gettext("Actions"),
                    name: "Edit",
                    orderable: false,
                    classes: {
                        btn: true,
                        "btn-primary": true,
                        "btn-sm": true,
                    },
                    component: ActionTableButtons,
                    meta: {
                        url: this.base_url + "/admin/standard-responses",
                        showActionButtons: this.showActionButtons
                    },
                },
            ],
            translate: {
                nextButton: this.$gettext('Next'),
                previousButton: this.$gettext('Previous'),
                placeholderSearch: this.$gettext('Search responses...'),
            },
        };
    },

    beforeCreate() {
        this.showActionButtons = !!(this.$root.user.roles.find(el => el.name === 'super admin'));
    },

    mounted() {
        this.url = this.base_url + "/admin/standard-responses-datatable";

        let self = this;

        this.$root.$on("get-datatable-row-id", function (id) {
            this.rowId = id;
        });

        this.$root.$on("modal-confirmed", function () {
            self.deleteRow(this.rowId);
        });
    },

    methods: {
        showRowNumber(id) {
            window.location = "/admin/standard-responses/" + id;
        },

        deleteRow(id) {
            let url = "/admin/standard-responses/delete/" + id;

            axios.post(url).then((res) => {
                if (res.status === 200) {
                    sessionStorage.setItem("alert_type", "success");
                    sessionStorage.setItem("message", this.$gettext("Standard Response deleted successfully"));

                    this.$root.$emit("show-flash-message");

                    this.$refs.responsesTable.getData();
                }
            }).catch(errors => {
                sessionStorage.setItem("alert_type", "danger");
                sessionStorage.setItem("message", this.$gettext("Something went wrong"));

                this.$root.$emit("show-flash-message");
            });
        },
    },
};
</script>
